import { Box, FullScreenPage } from "@skailer-com/uikit";
import { ApiFormType } from "@/types/forms/form.types.ts";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormResultForEmployeeModalContent } from "@/components/form-result/result-modal/components/FormResultForEmployeeModalContent.tsx";
import { PrintDocument, PrintHeader } from "@/components/print/index.ts";

type FormResultPrintWrapperProps = {
  form_type: ApiFormType;
};

export function FormResultPrintWrapper({ form_type }: FormResultPrintWrapperProps) {
  const { t } = useTranslation();
  const { id, employee_id } = useParams();

  const questionnaireId = id ? parseInt(id) : undefined;
  const employeeId = employee_id ? parseInt(employee_id) : undefined;

  return (
    <FullScreenPage>
      {questionnaireId && employeeId && (
        <Box className="py-6 print:py-0">
          <PrintDocument
            header={<PrintHeader title={t("common:view_responses")} />}
            footerLabel={t("core:print_generated_with")}
          >
            <FormResultForEmployeeModalContent
              questionnaireId={questionnaireId}
              employeeId={employeeId}
              type={form_type}
            />
          </PrintDocument>
        </Box>
      )}
    </FullScreenPage>
  );
}
